import type { JiraSoftwareReport } from '@atlassian/jira-navigation-apps-resources/src/services/sidebar/jsw-reports-sidebar-navigation/types.tsx';
import type { Reports } from '../../../common/types/index.tsx';

export const extractData = (reports: JiraSoftwareReport[] = []): Reports => {
	const applicableReportsSet = new Set(
		reports.filter((report) => report.isApplicable).map((report) => report.key),
	);
	return {
		hasOverview: true,
		hasBurnup: applicableReportsSet.has('jsw.report.sprint-burnup'),
		hasBurndown: applicableReportsSet.has('jsw.report.sprint-burndown'),
		hasVelocity: applicableReportsSet.has('jsw.report.velocity'),
		hasCumulative: true,
		hasControl: applicableReportsSet.has('jsw.report.control'),
	};
};
